import Nullstack from 'nullstack';
export default function IconBrandTwilio({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-twilio",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M21 12a9 9 0 1 1 -18 0a9 9 0 0 1 18 0z"
  }), "   ", Nullstack.element("circle", {
    cx: "9",
    cy: "9",
    r: "1"
  }), "   ", Nullstack.element("circle", {
    cx: "15",
    cy: "9",
    r: "1"
  }), "   ", Nullstack.element("circle", {
    cx: "15",
    cy: "15",
    r: "1"
  }), "   ", Nullstack.element("circle", {
    cx: "9",
    cy: "15",
    r: "1"
  }), " ");
}